import styled from 'styled-components';

const Content = styled.div`
  font-family: var(--google-sora-cdn);
  text-align: center;
`;

export default Content;
